import { SVGProps } from '@components/Icon/types';

export const Clock = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M6.73865 8.0244L6.73805 3.9485C6.73803 3.77453 6.87904 3.63348 7.05301 3.63345C7.22698 3.63343 7.36803 3.77444 7.36805 3.94841L7.36861 7.73391L11.311 6.74833C11.4797 6.70613 11.6508 6.80875 11.6929 6.97752C11.7351 7.1463 11.6325 7.31732 11.4637 7.35952L7.13042 8.44285C6.96164 8.48504 6.79062 8.38243 6.74842 8.21365C6.73727 8.16903 6.73623 8.12426 6.74387 8.08175C6.74045 8.06315 6.73866 8.04398 6.73865 8.0244Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.600006 7.41501C0.600006 3.65119 3.65119 0.600006 7.41501 0.600006C11.1788 0.600006 14.23 3.65119 14.23 7.41501C14.23 11.1788 11.1788 14.23 7.41501 14.23C3.65119 14.23 0.600006 11.1788 0.600006 7.41501ZM7.41501 1.23001C3.99913 1.23001 1.23001 3.99913 1.23001 7.41501C1.23001 10.8309 3.99913 13.6 7.41501 13.6C10.8309 13.6 13.6 10.8309 13.6 7.41501C13.6 3.99913 10.8309 1.23001 7.41501 1.23001Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'clock';
